import { z } from 'zod';
export const visibilitySchema = z.discriminatedUnion('visibility', [
    z.object({ visibility: z.literal('PUBLIC') }),
    z.object({ visibility: z.literal('TEAM'), teamId: z.string().min(1) }),
]);
export const gamePhaseSchema = z.enum([
    'SETUP',
    'ORGANIZATION_CREATION',
    'REVEAL',
    'ROUND_ACTIVE',
    'ROUND_CLOSED',
    'ROUND_RESOLVED',
    'BETWEEN_ROUNDS',
    'FINAL_DEBRIEF',
    'COMPLETED',
]);
export const roundStatusSchema = z.enum([
    'DRAFT',
    'OPEN',
    'CLOSED',
    'RESOLVED',
    'BROADCAST_PUBLISHED',
    'COMPLETE',
]);
export const gameSchema = z.object({
    gameId: z.string().min(1),
    phase: gamePhaseSchema,
    activeRoundNo: z.number().int().positive().nullable(),
    currentStateVersion: z.number().int().nonnegative(),
    version: z.number().int().nonnegative(),
    targetRounds: z.number().int().min(2).max(3),
    accessExpiresAt: z.string().datetime(),
});
export const roundSchema = z.object({
    gameId: z.string().min(1),
    roundNo: z.number().int().positive(),
    status: roundStatusSchema,
    version: z.number().int().nonnegative(),
});
export const teamSchema = z.object({
    gameId: z.string().min(1),
    teamId: z.string().min(1),
    credentialPK: z.string().min(1),
    displayName: z.string().min(1).max(160),
    version: z.number().int().nonnegative(),
});
export const scenarioSchema = z.object({
    gameId: z.string().min(1),
    title: z.string().min(1).max(200),
    publicMarkdown: z.string().min(1).max(30_000),
});
export const authoritativeTeamStateSchema = z.object({
    resources: z.record(z.string(), z.number().int()),
    capabilities: z.array(z.string().max(500)).max(40),
    liabilities: z.array(z.string().max(500)).max(40),
});
export const stateSnapshotSchema = z.object({
    gameId: z.string().min(1),
    version: z.number().int().nonnegative(),
    publicWorld: z.record(z.string(), z.unknown()),
    teams: z.record(z.string(), authoritativeTeamStateSchema),
    checksum: z.string().min(1),
});
export const auditEventSchema = z.object({
    auditId: z.string().min(1),
    gameId: z.string().min(1),
    occurredAt: z.string().datetime(),
    action: z.string().min(1),
    actorRole: z.enum(['TEAM', 'MODERATOR', 'SYSTEM']),
    teamId: z.string().optional(),
    target: z.string().min(1),
    correlationId: z.string().min(1),
    metadata: z.record(z.string(), z.unknown()).default({}),
});
//# sourceMappingURL=game.js.map